<script setup lang="ts">
  import DocumentInfoAccordion from './DocumentInfoAccordion.vue';
  import DocumentPrefixesSection from './DocumentPrefixesSection.vue';
  import DocumentRulesSection from './DocumentRulesSection.vue';
  import DocumentExamplesSection from './DocumentExamplesSection.vue';
  import DocumentIncorrectExamplesSection from './DocumentIncorrectExamplesSection.vue';
  import { IconImage } from '@/shared/ui';
  import InfoIcon from '@/shared/assets/icons/InfoIcon.svg';
</script>

<template>
  <div
    id="document-info"
    class="text-sm divide-y flex flex-col divide-border-color px-6"
  >
    <div class="flex gap-2 py-4">
      <IconImage
        :src="InfoIcon"
        alt="Info"
        class="text-gray-03"
      />
      <h2 class="text-gray-07 text-sm font-semibold">
        Informações importantes
      </h2>
    </div>

    <DocumentInfoAccordion title="Quais são os prefixos válidos?">
      <DocumentPrefixesSection />
    </DocumentInfoAccordion>

    <DocumentInfoAccordion title="Regras importantes">
      <DocumentRulesSection />
    </DocumentInfoAccordion>

    <DocumentInfoAccordion title="Exemplos corretos">
      <DocumentExamplesSection />
    </DocumentInfoAccordion>

    <DocumentInfoAccordion title="Exemplos incorretos">
      <DocumentIncorrectExamplesSection />
    </DocumentInfoAccordion>
  </div>
</template>
